<div class="array-title col-12" *ngIf="item?.placeholder">
  {{ item.placeholder && item.placeholder !== 'undefined' ? item.placeholder : '' }}:
</div>
<ng-container
  *ngFor="let groupData of formData?.data[item.formControlName]"
>
  <ng-container *ngFor="let control of item.arrSmartList" [ngSwitch]="true">
    <ng-container *ngIf="groupData[control.formControlName] || !formData?.options?.hideShowEmptyField">
      <div class="custom-list__item"
        [ngClass]="control.gridClasses"
        *ngSwitchCase="
          control.type === 'select' || control.type === 'select-filter'
        "
      >
        <div class="custom-list__line label">{{ control.label }}</div>
        <div class="custom-list__line">
          <ng-container
            *ngIf="
              control.optionListRequestAlias &&
              optionList &&
              optionList[control?.optionListRequestAlias]
            "
          >
            {{
              showSelectItem(
                groupData[control.formControlName],
                optionList[control?.optionListRequestAlias].optionList
              )
            }}
          </ng-container>

          <ng-container *ngIf="!control.optionListRequestAlias">
            {{
              showSelectItem(
                formData?.data[control.formControlName],
                control.optionList
              )
            }}
          </ng-container>
        </div>
      </div>

      <div class="custom-list__item"
        *ngSwitchCase="
          control.type === 'datepicker' ||
          control.type === 'datepicker-range-start' ||
          control.type === 'datepicker-range-end'
        "
      >
        <div class="custom-list__line label">{{ control.label }}</div>
        <div class="custom-list__line">
          <ng-container *ngIf="dateLocale === 'ru'">
            {{ groupData[control.formControlName] | date: 'dd.MM.yyyy' }}
          </ng-container>
          <ng-container *ngIf="dateLocale === 'en'">
            {{ groupData[control.formControlName] | date: 'MM/dd/yyyy' }}
          </ng-container>
        </div>
      </div>

      <div class="custom-list__item" *ngSwitchDefault>
        <div class="custom-list__line label">{{ control.label }}</div>
        <div class="custom-list__line">{{ groupData[control.formControlName] }}</div>
      </div>
    </ng-container>

  </ng-container>
  <span class="array-separator"></span>
</ng-container>
